import { reactive } from "vue";

// Localized official store badges, keyed by site locale (same codes as
// src/locales). Apple SVGs come from the marketing toolbox API
// (toolbox.marketingtools.apple.com); Google PNGs are the official
// *_badge_web_generic.png files with their built-in transparent padding
// cropped off so both badges align at the same display height.
//
// Site locale → badge asset name, for locales that share another locale's
// artwork instead of shipping a duplicate file (mirrors FLAG_ASSET_ALIASES
// in countryFlags.js). en-gb: both stores publish a single English badge.
// hi: Apple offers no Hindi badge (Google does), so only the App Store
// badge falls back to English.
const APP_STORE_BADGE_ALIASES = Object.freeze({
  "en-gb": "en-us",
  hi: "en-us",
});

const PLAY_BADGE_ALIASES = Object.freeze({
  "en-gb": "en-us",
});

export const storeBadgesStore = reactive({
  appStore: {},
  googlePlay: {},
  importBadges() {
    const appStoreContext = require.context(
      "@/assets/store-badges/app-store/",
      false,
      /\.svg$/
    );
    const googlePlayContext = require.context(
      "@/assets/store-badges/google-play/",
      false,
      /\.png$/
    );
    const appStore = {};
    appStoreContext.keys().forEach((key) => {
      appStore[key.replace("./", "").replace(".svg", "")] = appStoreContext(key);
    });
    const googlePlay = {};
    googlePlayContext.keys().forEach((key) => {
      googlePlay[key.replace("./", "").replace(".png", "")] = googlePlayContext(key);
    });
    this.appStore = appStore;
    this.googlePlay = googlePlay;
  },
  getAppStoreBadge(locale) {
    if (Object.keys(this.appStore).length === 0) this.importBadges();
    const asset = APP_STORE_BADGE_ALIASES[locale] || locale;
    return this.appStore[asset] || this.appStore["en-us"];
  },
  getPlayBadge(locale) {
    if (Object.keys(this.googlePlay).length === 0) this.importBadges();
    const asset = PLAY_BADGE_ALIASES[locale] || locale;
    return this.googlePlay[asset] || this.googlePlay["en-us"];
  },
});
